import React from "react";
import { ArrowRight, Play, ShieldCheck } from "lucide-react";
import { Button } from "./ui/button";
import { media, bookingUrl, translations } from "../mock";
import { useLang } from "../i18n/LanguageContext";

export default function Hero() {
  const { lang } = useLang();
  const T = translations[lang];
  const th = T.hero;

  return (
    <section id="home" className="relative overflow-hidden pt-40 pb-24 md:pt-48 md:pb-28">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-cblue/10 blur-3xl" />
        <div className="absolute top-40 -left-24 h-80 w-80 rounded-full bg-sky-tint blur-2xl" />
      </div>

      <div className="mx-auto max-w-7xl px-5 md:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <h1 className="mt-6 font-display text-4xl md:text-6xl font-extrabold leading-[1.05] text-navy">{th.title}</h1>
          <p className="mt-6 text-lg leading-relaxed text-slate-600 max-w-xl">{th.subtitle}</p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <Button onClick={() => { window.location.href = bookingUrl; }} className="group bg-navy hover:bg-navy-800 text-white rounded-full h-14 px-8 text-base font-semibold">
              {T.cta}
              <ArrowRight className="ml-2 rtl:mr-2 rtl:ml-0 h-5 w-5 transition-transform group-hover:translate-x-1 rtl:rotate-180" />
            </Button>
            <Button variant="ghost" className="group rounded-full h-14 px-6 text-base font-semibold text-navy hover:bg-sky-tint"
              onClick={() => document.getElementById("how")?.scrollIntoView({ behavior: "smooth" })}>
              <span className="mr-3 rtl:ml-3 rtl:mr-0 grid h-10 w-10 place-items-center rounded-full bg-cblue text-white transition-transform group-hover:scale-110">
                <Play className="h-4 w-4 fill-white" />
              </span>{th.secondaryCta}
            </Button>
          </div>
        </div>

        <div className="relative">
          <div className="relative rounded-[2rem] overflow-hidden device-shadow">
            <img src={media.heroImage} alt="CMED.AI in Qatar" className="w-full h-[440px] md:h-[520px] object-cover object-top" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy/25 to-transparent" />
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-5 md:px-8 mt-20">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 rounded-3xl bg-navy px-6 py-8 md:px-10">
          {T.stats.map((s, i) => (
            <div key={i} className="text-center">
              <p className="font-display text-2xl md:text-3xl font-extrabold text-white">{s.value}</p>
              <p className="mt-1 text-xs md:text-sm text-blue-200">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
